$(function(){

	$(window).on('load', function() {

		$('.js-fade_parent').waypoint(function (direction) {
			var activePoint = $(this.element);
			if (direction === 'down') {
				activePoint.addClass('is-active');
				setTimeout(function(){
					activePoint.next('.js-fade_child').addClass('is-active');
				},700);
				setTimeout(function(){
					activePoint.next().next('.js-fade_second').addClass('is-active');
				},1200);
			}
		}, {
			offset: '70%'
		});

	});

	$('.js-scroll[href^="#"]').click(function(){
		var adjust = 0;
		var speed = 400;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top + adjust;
		$('body,html').animate({scrollTop:position}, speed);
		return false;
	});

});
